const PREFIX = 'STAFF/';
export const GET_STAFF = 'GET_STAFF';
export const UPDATE_STAFF = 'UPDATE_STAFF';
export const SET_LOCATION = `${PREFIX}SET_LOCATION`;
export const UPDATE_REQUEST = `${PREFIX}UPDATE_REQUEST`;
